export const constants = {
  UPDATE_CATEGORIES: "UPDATE_CATEGORIES",
  UPDATE_PRODUCT: "UPDATE_PRODUCT",
};
